﻿package com.mgacreative.hotelru.feature.admin.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotelru.core.tenant.TenantSession
import com.mgacreative.hotelru.domain.model.Room
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import com.mgacreative.hotelru.domain.model.RoomTypes
import com.mgacreative.hotelru.domain.repository.RoomRepository

class AdminRoomViewModel(
    private val roomRepository: RoomRepository,
    private val tenantSession: TenantSession
) : ViewModel() {

    private val _rooms = MutableStateFlow<List<Room>>(emptyList())
    val rooms: StateFlow<List<Room>> = _rooms.asStateFlow()

    val roomTypes: List<String> = RoomTypes.list

    fun loadData() {
        viewModelScope.launch {
            _rooms.value = roomRepository.getRooms()
        }
    }

    fun addRoom(roomNumber: String, roomType: String) {
        viewModelScope.launch {
            val tenantId = tenantSession.currentTenantId ?: "00000000-0000-0000-0000-000000000000" // Fallback for testing
            val newRoom = Room(
                tenantId = tenantId,
                roomType = roomType,
                roomNumber = roomNumber,
                status = "CLEAN"
            )
            println("Adding room: $newRoom")
            val added = roomRepository.addRoom(newRoom)
            if (added != null) {
                println("Room added successfully: $added")
                _rooms.value = _rooms.value + added
            } else {
                println("Failed to add room, repository returned null.")
            }
        }
    }

    fun deleteRoom(roomId: String) {
        viewModelScope.launch {
            val success = roomRepository.deleteRoom(roomId)
            if (success) {
                _rooms.value = _rooms.value.filter { it.id != roomId }
            }
        }
    }

    fun updateRoom(roomId: String, newType: String, newNumber: String, newStatus: String) {
        viewModelScope.launch {
            val room = _rooms.value.find { it.id == roomId } ?: return@launch
            val updatedRoom = room.copy(roomType = newType, roomNumber = newNumber, status = newStatus)
            val savedRoom = roomRepository.updateRoom(updatedRoom)
            if (savedRoom != null) {
                _rooms.value = _rooms.value.map { if (it.id == savedRoom.id) savedRoom else it }
            }
        }
    }
}

